/**
 * AI Settings - 日本語ローカライゼーション
 */

export default {
    aiSettings: {
        title: 'AI 設定',
        description: 'AIがリクエストにどのように応答するかを設定',
        loading: '設定を読み込み中...',
        saving: '保存中...',
        saveSuccess: '設定が正常に保存されました',
        saveError: '設定の保存に失敗しました。もう一度お試しください',
        selectLanguage: 'AI出力言語を選択',

        outputLanguage: {
            title: 'AI 出力言語',
            description: '質問への回答やコンテンツ生成時にAIが使用する言語を選択',
        },

        error: {
            title: 'エラー',
        },

        info: {
            title: '仕組み：',
            point1: 'AIは選択した言語ですべての会話に応答します',
            point2: '設定はすべてのデバイス間で同期されます',
            point3: '変更は新しい会話に即座に反映されます',
        },
    },
};
